import React, { useState, useEffect } from "react";

import ScaricaButton from "../box_button/scarica_app_button.js";
import ChatAssistenza from "../box_button/chat_assistenza_button.js";
import Promotion from "../box_button/promotion_button.js";

import { useTranslation } from "react-i18next";

import casino_live from "./assets/casino-live.png";

import gift from "./assets/gift.png";
import slot from "./assets/slot.png";
import sport from "./assets/sport.png";
function BoxNavigation() {
    const { t } = useTranslation();

    return (
        <>
            <div className="container-fluid box-underCarousel">
                <div className="row">
                    <div className="col-3">
                        <a href="/sport" className="box-navigation-link">
                            <div className="box-navigation ">
                                <div className="text">
                                    <h4>{t("Sport")}</h4>
                                    <p>+120 {t("Different_sports")}</p>
                                </div>
                                <img src="/assets/img/sport.png" />
                            </div>
                        </a>
                    </div>

                    <div className="col-3">
                        <a href="/casino" className="box-navigation-link">
                            <div className="box-navigation">
                                <div className="text">
                                    <h4>{t("Casino")}</h4>
                                    <p>10.000+ {t("Slot_game")}</p>
                                </div>
                                <img src="/assets/img/slot.png" />
                            </div>
                        </a>
                    </div>

                    <div className="col-3">
                        <a href="/casino-live" className="box-navigation-link">
                            <div className="box-navigation">
                                <div className="text">
                                    <h4>{t("Casino_live")}</h4>
                                    <p>{t("Get_many_rewards_end_offers")}</p>
                                </div>
                                <img src="/assets/img/casino-live.png" />
                            </div>
                        </a>
                    </div>

                    <div className="col-3">
                        <div className="box-navigation promotionbox">
                            <div className="text">
                                <h4>{t("Promotions")}</h4>
                                <p>{t("Discover_all_our_offers")}</p>
                            </div>
                            <img src="/assets/img/gift.png" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BoxNavigation;
